import { PrimaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

import { MAX_SAVED_VIEWS } from "./saved-views";

interface MaxViewsModalProps {
  isOpen: boolean;
  close: () => void;
}

export const MaxViewsModal = ({ isOpen, close }: MaxViewsModalProps) => {
  return (
    <Modal
      titleContent={
        <div className="font-bold">Maximum number of saved views reached</div>
      }
      hideCloseButton
      isOpen={isOpen}
      onClose={close}
    >
      <p className="text-sm mb-4 text-[#717680]">
        You can create up to {MAX_SAVED_VIEWS} saved views. You will need to
        delete a previously saved view in order to save this one.
      </p>
      <PrimaryButton className="mt-12" onClick={close}>
        OK
      </PrimaryButton>
    </Modal>
  );
};
